<template>
<w-settings-content-template>
  <w-schedule-view slot="content" ref="scheduleView" managetypeId="SMS" />
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WScheduleView from './components/ScheduleView';

export default {
  name: 'WConfigScheduleSettings',
  components: {
    WSettingsContentTemplate,
    WScheduleView,
  },
  mounted() {
    this.$refs.scheduleView.loadData();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/ServerScheduleSettings.vue